var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.metaReady || _setup.coldStart)?_c('div',{attrs:{"id":"footer-container"}},[(_setup.showDefaultFooter)?_c(_setup.SportsDefaultFooter):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }